// TagType is generated from the server's TagType (members + integer values are
// the wire contract); re-exported from @aa/wire. This file keeps the
// display-ordered collection helper. See design/wiki/wire-schemas.md.
import { TagType } from "@aa/wire";

export { TagType };

export const tagTypeCollection = [
  TagType.Category,
  TagType.Section,
  TagType.Topic,
  TagType.Group,
  TagType.Variable,
];
